module.exports = __webpack_public_path__ + "static/img/couponRule.536e60e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/couponRule.jpg
// module id = +zWY
// module chunks = 0